import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@core/normalize.css/normalize.css';
import { BasicLayout, BasicLayoutChildren } from './BasicLayout';
import { HeaderLayout } from './HeaderLayout';
import { SiderLayout } from './SiderLayout';
import { useLocation } from 'react-router-dom';
import { ContentLayout } from './ContentLayout';
export const SmartLayout = ({ headerType, header = true, sider = true, withoutSiderAndHeaderRouter = [], withoutHeaderRouter = [], withoutSiderRouter = [], canChangeCompany = false, headerTabs = [], renderLayoutType = () => undefined, children, hasBase = true, ...rest }) => {
    const location = useLocation();
    const layoutType = renderLayoutType?.(location.pathname);
    if (layoutType) {
        if (layoutType === '1')
            return _jsx(ContentLayout, {});
        if (layoutType === '2')
            return (_jsx(HeaderLayout, { headerType: headerType, canChangeCompany: canChangeCompany, headerTabs: headerTabs, hasBase: hasBase }));
        if (layoutType === '3')
            return _jsx(SiderLayout, {});
    }
    if (withoutSiderAndHeaderRouter?.includes(location.pathname)) {
        return _jsxs(ContentLayout, { children: [" ", children] });
    }
    if (header && !sider) {
        return (_jsx(HeaderLayout, { headerType: headerType, canChangeCompany: canChangeCompany, headerTabs: headerTabs, hasBase: hasBase }));
    }
    if (sider && !header) {
        return _jsx(SiderLayout, {});
    }
    const params = {
        canChangeCompany,
        headerTabs,
        headerType,
        ...rest,
    };
    return children ? (_jsx(BasicLayoutChildren, { ...params, children: children })) : (_jsx(BasicLayout, { ...params }));
};
